/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Forward_Email_InstructionsInputs */

const en_common_forward_email_instructions = /** @type {(inputs: Common_Forward_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll turn emails and newsletters into audio. Forward them to`)
};

const es_common_forward_email_instructions = /** @type {(inputs: Common_Forward_Email_InstructionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertiremos correos y newsletters en audio. Reenvíalos a`)
};

/**
* | output |
* | --- |
* | "We'll turn emails and newsletters into audio. Forward them to" |
*
* @param {Common_Forward_Email_InstructionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_forward_email_instructions = /** @type {((inputs?: Common_Forward_Email_InstructionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Forward_Email_InstructionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_forward_email_instructions(inputs)
	return en_common_forward_email_instructions(inputs)
});